import React from 'react';
import { motion } from 'framer-motion';
import { ArrowUpRight } from 'lucide-react';
import { demoIncludes, demoNotice, demoPlanned, demoSwitchNote, noetivraDemoUrl } from '../../data/noetivra';
import { fadeUp } from '../../utils/motion';
export function NoetivraDemo() {
  return <section id="demo" aria-labelledby="demo-title" className="scroll-mt-20 bg-white border-b border-line py-20 lg:py-28" data-id="element-868" data-mp="2drrsfhbhhb3s">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16" data-id="element-869" data-mp="1q15mpwoyc2wy">
        <motion.div {...fadeUp} className="lg:col-span-5" data-id="element-870" data-mp="1m1nbxtquh87u">
          <p className="text-sm font-medium text-teal mb-3" data-id="element-871" data-mp="1zztr3so0kji6">Try the demo</p>
          <h2 id="demo-title" className="font-heading font-bold text-3xl lg:text-4xl text-ink-dark tracking-tight leading-tight mb-6" data-id="element-872" data-mp="1zy0kgddehza6">
            Explore the Noetivra prototype
          </h2>
          <p className="inline-block bg-surface-muted border border-line rounded-md px-3 py-1.5 text-sm font-medium text-navy" data-id="element-873" data-mp="3bhd0k2s6tip6">
            {demoNotice}
          </p>
          <p className="mt-6 text-lg text-ink-dark leading-relaxed" data-id="element-874" data-mp="i4h4riv8mm3q">{demoSwitchNote}</p>
          <a href={noetivraDemoUrl} target="_blank" rel="noopener noreferrer" className="mt-8 inline-flex items-center justify-center gap-2 bg-navy hover:bg-navy-light text-white font-semibold px-6 py-3.5 rounded-md transition-colors duration-150 whitespace-nowrap" data-id="element-875" data-mp="n3by3eqtzt23">
            Open Noetivra Demo
            <ArrowUpRight size={18} aria-hidden="true" data-id="element-876" data-mp="3vic72qedqazy" />
            <span className="sr-only" data-id="element-877" data-mp="4enhv63ambwn">(opens in a new tab)</span>
          </a>
        </motion.div>

        <motion.div {...fadeUp} className="lg:col-span-7 grid grid-cols-1 sm:grid-cols-2 gap-10 lg:pt-10" data-id="element-878" data-mp="9c6vq4w2wmo2">
          <div data-id="element-879" data-mp="e58bef440q8p">
            <h3 className="font-heading font-bold text-lg text-ink-dark mb-4 pb-3 border-b border-line" data-id="element-880" data-mp="e5rwu5syxwrh">In the demo now</h3>
            <ul className="space-y-3" data-id="element-881" data-mp="3hss3xjgvzbq4">
              {demoIncludes.map(item => <li key={item} className="flex gap-3 text-ink-dark" data-id="element-882" data-mp="3hqfgiqsd095o">
                  <span aria-hidden="true" className="mt-2.5 h-1.5 w-1.5 shrink-0 rounded-full bg-teal" data-id="element-883" data-mp="39qhu9yp41r38" />
                  {item}
                </li>)}
            </ul>
          </div>
          <div data-id="element-884" data-mp="3jhcj9atqr4sd">
            <h3 className="font-heading font-bold text-lg text-ink-dark mb-4 pb-3 border-b border-line" data-id="element-885" data-mp="3jjym4x5osw49">Planned capabilities</h3>
            <ul className="space-y-3" data-id="element-886" data-mp="2qsyg6gnspi9y">
              {demoPlanned.map(item => <li key={item} className="flex gap-3 text-ink-muted" data-id="element-887" data-mp="2lu52oo8idr9s">
                  <span aria-hidden="true" className="mt-2.5 h-1.5 w-1.5 shrink-0 rounded-full border border-ink-muted" data-id="element-888" data-mp="2lvyc2baiaplh" />
                  {item}
                </li>)}
            </ul>
          </div>
        </motion.div>
      </div>
    </section>;
}